export default __webpack_public_path__ + "static/media/intro-video-thumbnail.92100bd7.jpg";